<template>
  <button @click="show" class="btn btn-primary btn-sm is-border-1 mr-1" type="button">
    <font-awesome-icon icon="list"/>
    {{ $t('templateList') }}
    <b-modal v-model="showList" :title="brandName.name + ': ' + $t('smsTemplateTitle')" size="xl" no-close-on-backdrop no-enforce-focus>
      <div class="col-12">
        <div class="c-sorting" v-if="['owner', 'admin', 'tech', 'account', 'operationsManager'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right"
                            size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize"
                            @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items && items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-2">{{ $t('name') }}</div>
            <div class="col-lg-6">{{ $t('info') }}</div>
            <div class="col-lg-2">{{ $t('status') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-2">{{ item.name }}</div>
            <div class="col-lg-6">
              <p><b>{{$t('content')}}</b>: <span v-html="item.content.replace(/\n/g, '<br/>')" ></span></p>
              <p><b>{{$t('numberOfCharacter')}}: </b> {{item.characterCount ? item.characterCount : '--'}}</p>
              <p><b>{{$t('numberOfSms')}}: </b> {{item.numberOfSms ? item.numberOfSms : '--'}}</p>
              <p>
                <span v-if="item.isUnicode" class="badge badge-primary">{{$t('isUnicode')}}</span>
                <span v-else class="badge badge-secondary">{{$t('isNotUnicode')}}</span>
              </p>
            </div>
            <div class="col-lg-2">
              <p>
                <span class="badge badge-success" v-if="item.approveTime">{{ $t('approved') }}</span>
                <span class="badge badge-danger" v-else-if="item.denyTime">{{ $t('denied') }}</span>
                <!-- Cả hai mốc = 0 là mẫu mới chờ xử lý, trước đây cột này bỏ trống. -->
                <span class="badge badge-warning" v-else>{{ $t('waiting') }}</span>
              </p>
            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-button__col">
                    <button @click="update(item._id)" class="btn btn-info btn-sm mr-1 mb-1" type="button">
                      <font-awesome-icon icon="edit"/>
                      {{ $t('edit') }}
                    </button>
                    <button v-if="!item.approveTime && ['owner', 'admin', 'account', 'operationsManager'].includes($store.state.user.role)" @click="approve(item._id)"
                            class="btn btn-success btn-sm mr-1 mb-1" type="button">
                      <font-awesome-icon icon="check"/>
                      {{ $t('activate') }}
                    </button>
                    <button v-if="!item.denyTime && ['owner', 'admin', 'account', 'operationsManager'].includes($store.state.user.role)" @click="deny(item._id)"
                            class="btn btn-danger btn-sm mr-1 mb-1" type="button">
                      <font-awesome-icon icon="window-close"/>
                      {{ $t('lock') }}
                    </button>
                    <button v-if="['owner', 'admin', 'tech'].includes($store.state.user.role)" @click="del(item._id)"
                            class="btn btn-danger btn-sm mr-1 mb-1" type="button">
                      <font-awesome-icon icon="trash"/>
                      {{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging" v-if="itemCount > filterFormModel.pageSize">
          <b-pagination size="sm" class="pagination pagination-sm justify-content-center"
                        v-model="filterFormModel.page" :total-rows="itemCount"
                        :per-page="filterFormModel.pageSize"
                        @input="load">
          </b-pagination>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-else>
        <span>{{ $t('notFoundSearch') }}</span>
      </div>
      <b-modal v-model="showForm" size="lg"
               :title="brandName.name + ': ' + formTitle + ' template'" no-close-on-backdrop no-enforce-focus>
        <form autocomplete="off">
          <form-input :label="$t('templateName')" :model="formModel" attribute="name" :errors="formErrors"></form-input>
          <form-textarea :label="$t('smsContent')" :model="formModel" attribute="content" row="6"
                         :errors="formErrors"></form-textarea>
          <form-input label="Ref" :model="formModel" attribute="ref" :errors="formErrors" placeholder="Mã template từ đối tác, không bắt buộc"/>
          <form-checkbox :chk-label="$t('isUnicode')" :model="formModel" attribute="isUnicode" :errors="formErrors"></form-checkbox>
          <p>{{ $t('numberOfCharacter') }}:
            <b-spinner v-if="countLoading" small></b-spinner>
            <span v-else
                  :class="formModel.characterCount>characterLimit ? 'text-danger' : ''">{{ formModel.characterCount }}</span>/{{ characterLimit }}
          </p>
          <p>
            {{ $t('numberOfSms') }}: {{ formModel.numberOfSms }}
          </p>
          <div class="alert alert-warning" v-if="formModel.characterCount>characterLimit" >Cần phải xin mở khoá tại nhà mạng</div>
          <div class="alert alert-info" v-html="$t('smsTemplateNote')"></div>
        </form>
        <template v-slot:modal-footer>
          <b-button variant="secondary" class="float-right" @click="showForm = false">{{ $t('cancel') }}
          </b-button>
          <b-button v-if="['owner', 'admin', 'tech', 'account', 'operationsManager'].includes($store.state.user.role)" :disabled="saveLoading || formModel.numberOfSms>9" variant="primary"
                    class="float-right" @click="save">
            <b-spinner v-if="saveLoading" small></b-spinner>
            {{ $t('save') }}
          </b-button>
        </template>
      </b-modal>
    </b-modal>
  </button>
</template>

<script>
import {countSms} from '@/utils/smsTemplateCounter';
import list from "@/mixins/List";
import crud from '@/mixins/CRUD';

export default {
  mixins: [list, crud],
  props: ['brandName'],
  data: function () {
    return {
      service: '/sms-template',
      showList: false,
      autoLoad: false,
      defaultFormModel: {
        brandName: this.brandName._id,
        client: this.brandName.client,
        content: null,
        characterCount: 0,
        numberOfSms: 1,
        isUnicode: false
      },
      defaultFilterFormModel: {
        brandName: this.brandName._id
      },
      characterCount: 0,
      countLoading: false,
      saveLoading: false,
    }
  },
  computed: {
    characterLimit() {
      return countSms(this.formModel.content, this.formModel.isUnicode).limit;
    }
  },
  watch: {
    "formModel.content": {
      handler() {
        this.calSmsCount()
      }
    },
    "formModel.isUnicode": {
      handler() {
        this.calSmsCount()
      }
    }
  },
  methods: {
    // Dùng bản đếm chung để màn này, form khách và backend không ra ba con số khác nhau.
    // Vẫn giữ ô tích có dấu vì admin đôi khi cần ép theo cách nhà mạng đã chốt.
    calSmsCount() {
      const result = countSms(this.formModel.content, this.formModel.isUnicode);
      this.formModel.characterCount = result.characterCount;
      this.formModel.numberOfSms = result.numberOfSms;
      this.paramTemplate = result.params;
    },
    show() {
      this.load();
      this.showList = true
    },
    approve: function (id) {
      this.$swal({
        title: this.$t('approveConfirm'),
        text: this.$t('approveAlert'),
        icon: "info",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          this.updateLoading = true;
          this.$service.put(this.service + '/approve/' + id).then(response => {
            if (response.data && !response.data.msg) {
              this.load();
              this.$bus.$emit('loadBrandName')
            } else {
              this.$swal({
                title: this.$t('error'),
                text: response.data.msg,
                icon: 'error',
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            this.updateLoading = false;
          });
        }
      });
    },
    deny: function (id) {
      this.$swal({
        title: this.$t('denyConfirm'),
        text: this.$t('denyAlert'),
        icon: "info",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          this.updateLoading = true;
          this.$service.put(this.service + '/deny/' + id).then(response => {
            if (response.data && !response.data.msg) {
              this.load();
            } else {
              this.$swal({
                title: this.$t('error'),
                text: response.data.msg,
                icon: 'error',
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            this.updateLoading = false;
          });
        }
      });
    },
    save: function (evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.saveLoading = true;
      let method = 'post';
      let url = this.service;
      if (this.formModel.id) {
        method = 'put';
        url += '/' + this.formModel.id;
      }
      this.formModel.params = this.paramTemplate;
      this.formModel.msgLength = this.msgLength;

      return this.$service({url: url, method: method, data: this.formModel}).then(response => {
        this.showForm = false;
        if (this.load) {
          this.load();
        }
        if (this.reloadBus) {
          this.$bus.$emit(this.reloadBus);
        }
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t(this.formModel.id ? 'updated' : 'created'),
            icon: 'success',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
          this.$bus.$emit('reloadSMSBrandNames');
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t(this.formModel.id ? 'updateFailed' : 'createFailed'),
            icon: 'error',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
        }
        return response.data;
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
          this.showForm = false;
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        this.saveLoading = false;
      });
    },
  },
  i18n: {
    messages: {
      en: {
        smsTemplateTitle: "SMS Template list",
        template: "Template",
        denied: "Denied",
        approved: "Approved",
        waiting: "Waiting",
        deny: "Deny",
        approve: "Approve",
        draft: "Draft",
        approveConfirm: "Are you sure to approve this template?",
        approveAlert: "This action can't be undone",
        noTemplateFound: "No template found",
        templateName: "Template name",
        smsContent: "SMS content",
        numberOfCharacter: "Number of character",
        smsTemplateNote: "Use {key,length} to indicate a parameter. <br>Namely: <br>- \"key\" is name of placeholder<br>- \"length\" is the length of replaced word",
        content: "content",
        save: "Save",
        templateList: "Template list",
        numberOfSms: "Number of SMS",
        info: "Info",
        isUnicode: "Is unicode",
        isNotUnicode: "Not unicode"
      },
      vi: {
        smsTemplateTitle: "Danh sách mẫu tin nhắn",
        template: "Mẫu",
        denied: "Đã từ chối",
        approved: "Đã duyệt",
        waiting: "Đợi duyệt",
        deny: "Từ chối",
        approve: "Duyệt",
        draft: "Nháp",
        approveConfirm: "Bạn có chắc muốn kích hoạt mẫu tin nhắn này?",
        approveAlert: "Hành động này không thể hoàn tác",
        denyConfirm: "Bạn có chắc muốn khoá mẫu tin nhắn này?",
        denyAlert: "Hành động này không thể hoàn tác",
        noTemplateFound: "Chưa có template nào",
        templateName: "Tên template",
        smsContent: "Nội dung",
        numberOfCharacter: "Số ký tự",
        smsTemplateNote: "Hướng dẫn tạo nội dung SMS:<br>- Dùng {key,sokytu} thể hiện nội dung có thể thay đổi trong mẫu tin nhắn<br>- \"key\" là tên nội dung thay đổi, \"sokytu\" là độ dài ký tự <br>- Đối với tin nhắn Tiếng Việt có dấu, số ký tự tối đa là 603.<br>- Đối với tin nhắn Tiếng Việt không dấu, số ký tự tối đa là 1377.<br>- Số ký tự tính theo trường hợp xấu nhất: mỗi tham số coi như dài hết mức đã khai",
        content: 'Nội dung',
        save: 'Lưu',
        templateList: "Danh sách template",
        numberOfSms: "Số lượng SMS",
        info: "Thông tin",
        isUnicode: "Có dấu",
        isNotUnicode: "Không dấu"}
    }
  }
}
</script>